import CardCurrency from '@/components/shared/CardCurrency/CardCurrency';
import { AffiliateReportSummary } from '@/@types/AffiliateReport';

interface Props {
  summary: AffiliateReportSummary;
  isLoading: boolean;
  revenueLabel: string;
  commissionsLabel: string;
}

export default function AffiliateSummaryCards({
  summary,
  isLoading,
  revenueLabel,
  commissionsLabel,
}: Props) {
  return (
    <section className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      <CardCurrency
        text={revenueLabel}
        value={summary.totalRevenue}
        status="paid"
        isLoading={isLoading}
      />
      <CardCurrency
        text={commissionsLabel}
        value={summary.totalCommissions}
        status="lightGreen"
        isLoading={isLoading}
      />
    </section>
  );
}
